export const confirmDeleteBusinessLocation = async (functionParameters = {}) => {

    console.log("THIS IS THE PARAMETER IN confirmDeleteBusinessLocation ", functionParameters);

    const axios = (await import(/* webpackPrefetch: true */ "axios")).default;

    let {submissionData, stripeSubscriptionId, name, token, addressToken, apiEndPoint, preloader, smetioSmartbox, accountType, language, smetioPresentationClass, smetioPresentationId, smartbox, textClass, model, uniqueValues, titleClass, subTitleClass, paragraphClass } = functionParameters;
    
    const appClass = window.smetioApp;
    
    const sideMenuItems = window.currentSideMenuItems;
    const currentlyVisibleSideMenuItemName = window.currentlyVisibleSideMenuItemName;
    const smetioAppUi = window.currentSmetioAppUi;

    preloader.show();

    // const url = `${apiEndPoint}/businessLocations/delete/${language}`;
    const url = `${apiEndPoint}/apps/${appClass.appUserInterface}/businessLocations/delete/${language}`;

    const modelPath = "loggedInUser/authenticationModel";
    const res = await axios.post(url, { token, addressToken, stripeSubscriptionId, modelPath, ...submissionData }).then(async (response) => {
  
        // console.log("Here is the response from createNewBusinessLocation : ",response );
    
        let model = response.data;
    
        if (model.error) return window.smetioVisitor.showNotification({ type:"danger", body: [{ message: model.msg }] });
        
        if (model.success) window.smetioVisitor.showNotification({ type:"success", body: [{ message: model.msg }] });
        
        smetioSmartbox.close();

        // if(smetioAppUi.sideMenu.dataGroups["businessLocations"]) return smetioAppUi.sideMenu.dataGroups["businessLocations"].deleteDataPresentation(smetioPresentationId);
        sideMenuItems["businessLocations"].onClick();
      
    }).catch((error) => {
    
        console.log(error);
        return window.smetioVisitor.showNotification({type:"danger", body: [{ message: "txt423"}]});
    
    }).finally(() => {
        preloader.hide();
    });
    
    
};
